import { fetchServerNow } from './api'

// 야간 판정 (KST 기준): 20:30(1230분) ~ 익일 08:00(480분)
const NIGHT_START_MIN = 20 * 60 + 30 // 1230
const NIGHT_END_MIN = 8 * 60 // 480
const KST_OFFSET_MS = 9 * 60 * 60 * 1000

// 서버시각 보정 오프셋(serverEpoch - clientEpoch). 페이지당 1회 prime 후 캐시(인스턴스 공유).
let serverOffsetMs = 0
let primePromise: Promise<void> | null = null

function primeServerTime(apiBaseUrl: string): Promise<void> {
  if (!primePromise) {
    primePromise = fetchServerNow(apiBaseUrl).then(serverEpoch => {
      if (serverEpoch != null) serverOffsetMs = serverEpoch - Date.now()
    })
  }
  return primePromise
}

function nowMs(): number {
  return Date.now() + serverOffsetMs
}

export type NightState = { isNight: boolean; callbackTime: string }

export function useNightConsent() {
  /**
   * 서버시각(KST) 기반 야간 판정 + 거부 시 콜백 안내 문구 산출.
   *
   * 야간 범위: 20:30 ~ 익일 08:00 (KST)
   * 거부 시 콜백 문구:
   *   - 00:00~08:00 → '금일 14시 이후'
   *   - 20:30~24:00 → '익일 10시 이후'
   */
  const resolveNightState = async (apiBaseUrl: string): Promise<NightState> => {
    await primeServerTime(apiBaseUrl)
    const kst = new Date(nowMs() + KST_OFFSET_MS)
    const minutes = kst.getUTCHours() * 60 + kst.getUTCMinutes()

    const isNight = minutes >= NIGHT_START_MIN || minutes < NIGHT_END_MIN
    const callbackTime = minutes < NIGHT_END_MIN ? '금일 14시 이후' : '익일 10시 이후'

    return { isNight, callbackTime }
  }

  return { resolveNightState }
}
